import React from 'react';
import TabbedPage from '../../../Elements/TabbedPage';
import TpClientPaymentsAdmin from './TpClientPaymentsAdmin';
import TpAppliedReportParentAdmin from './TpAppliedReportParentAdmin';

const TpClientPaymentParentAdmin = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const tab = urlParams.has('tab') ? parseInt(urlParams.get('tab')) : 0;

  const tabs = [
    {
      label: 'All Payments',
      id: 'allpayments',
      icon: 'fa-solid fa-money-check',
      component: <TpClientPaymentsAdmin type='all' />,
    },
    {
      label: 'Payments with Unapplied Balance',
      id: 'unappliedbalance',
      icon: 'fa-solid fa-money-check-dollar',
      component: <TpClientPaymentsAdmin type='with unpaid' />,
    },
    {
      label: 'Prepayments',
      id: 'prepayments',
      icon: 'fa-solid fa-check',
      component: <TpClientPaymentsAdmin type='pre-payments' />,
    },
    {
      label: 'Applied Payments Report',
      id: 'appliedpaymentsreport',
      icon: 'fa-solid fa-file-invoice-dollar',
      component: <TpAppliedReportParentAdmin />,
    },
  ];

  return (
    <div className='contentwrapper'>
      <div className='bg-white p-1'>
        <div className='TabbedPage'>
          <TabbedPage
            tabs={tabs}
            openOnTab={tab}
            removeSearchParametersOnTabChange={true}
          />
        </div>
      </div>
    </div>
  );
};

export default TpClientPaymentParentAdmin;
